import { savePromotionCodeRecord } from '@src/lib/api/promotion'
import { SavePromotionCodeRecordDto } from '@src/type/promotion'
import { useMutation } from '@tanstack/react-query'

export function useSavePromotionCodeRecordMutate() {
	const useMutationResult = useMutation<unknown, unknown, SavePromotionCodeRecordDto>((saveDto) =>
		savePromotionCodeRecord(saveDto),
	)

	return useMutationResult
}
